//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
import IframeView from "@/components/public/IframeView";
export default {
  name: "DialogNeed",
  components: {
    Sift: Sift,
    IframeView: IframeView
  },
  props: [],
  data: function data() {
    return {
      show: false,
      loading: false,
      siftData: [],
      list: [],
      pageNum: 1,
      pageSize: 20,
      total: 0,
      hasContent: false
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    fetchSiftData: function fetchSiftData() {
      var _this = this;

      this.loading = true;
      this.$http.post("/baseTask/queryToDoTask").then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          _this.siftData = data.resData.siftData;

          _this.$nextTick(function () {
            _this.initPage();
          });
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    fetchList: function fetchList() {
      var _this2 = this;

      var obj = {};

      if (this.siftData.length > 0) {
        obj = this.$refs.needSift.getValue();
      }

      obj.pageNum = this.pageNum;
      obj.pageSize = this.pageSize;
      this.loading = true;
      this.$emit("fetch-msg-count");
      this.$http.post("/baseTask/toDoTask", this.$qs.stringify(obj)).then(function (_ref2) {
        var data = _ref2.data;

        if (data.resCode == 0) {
          _this2.list = data.resData.list;
          _this2.total = data.resData.total;
          _this2.hasContent = _this2.list.length && _this2.list[0].content ? true : false;
        }

        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    initPage: function initPage() {
      this.pageNum = 1;
      this.fetchList();
    },
    changeSize: function changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage: function changePage(value) {
      this.pageNum = value;
      this.fetchList();
    },
    showView: function showView() {
      this.show = true;

      if (this.siftData.length == 0) {
        this.fetchSiftData();
      } else {
        this.initPage();
      }
    },
    clickRow: function clickRow(item) {
      this.$refs.iframeView.showView(item.taskUrl, item.taskInstId);
    }
  },
  watch: {},
  filters: {}
};